module.exports = __webpack_public_path__ + "static/messages_fin_v1-e1c929ff818a2caa880f0e85b6dcf5b2.mp4";